// extracted by mini-css-extract-plugin
module.exports = {"list":"_283e148"};